var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.toasts.length)?_c('div',{staticClass:"fixed z-[100] top-4 right-4 space-y-2 w-80",attrs:{"role":"status","aria-live":"polite"}},_vm._l((_vm.toasts),function(t){return _c('div',{key:t.id,class:[
      'rounded-md shadow-medium border px-4 py-3 text-sm flex items-start gap-2',
      t.type === 'success' ? 'bg-green-50 border-green-200 text-green-800' : '',
      t.type === 'error' ? 'bg-red-50 border-red-200 text-red-800' : '',
      t.type === 'info' ? 'bg-blue-50 border-blue-200 text-blue-800' : '',
      t.type === 'warning' ? 'bg-yellow-50 border-yellow-200 text-yellow-800' : ''
    ]},[_c('span',{staticClass:"font-medium"},[_vm._v(_vm._s(t.title))]),_c('span',{staticClass:"ml-auto cursor-pointer opacity-70 hover:opacity-100",on:{"click":function($event){return _vm.dismiss(t.id)}}},[_vm._v("✕")])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }